export const ENDPOINTS = {
  codeVerifier: '/api/auth/code-verifier',
  vkCallback: '/api/auth/vk/callback',
  createPayment: '/api/yookassa/create-payment',
  returnURL: '/api/yookassa/return',
  createMockPayment: '/api/yookassa/mocks/mock-create-payment',
  mockWebhook: '/api/yookassa/mocks/mock-webhook',
  // mockVkCallback: '/api/auth/mock-vk/callback',
  checkPaymentStatus: '/api/yookassa/check-payment-status',
  mockCreatePayment: '/api/mocks/create-payment',
  mockPaymentResult: '/api/mocks/payment-result',
  paymentSucceesUrl: '/api/payment-success',
  me: '/api/users/me',
  continueSignUp: '/api/sign-up/continue',
  cancelSignUp: '/api/sign-up/cancel',
  deleteSignUpSession: '/api/sign-up/delete-session',
  clearSignUpCookies: '/api/sign-up/clear-session-cookies',
  keepAlive: '/api/session/keep-alive',
  logout: '/api/auth/logout',
  logError: '/api/log-error',
  cookieConsent: '/api/cookies/cookie-consent',
  checkCookieConsent: '/api/cookies/check-cookie-consent',
  cookieText: '/api/cookies/cookie-text'
};

export const YOOKASSA_PAYMENT_API_URL = 'https://api.yookassa.ru/v3/payments';
export const YOOKASSA_REFUND_API_URL = 'https://api.yookassa.ru/v3/refunds';
